import * as React from 'react';
export const mobilepaySvg = React.forwardRef(function mobilepaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#5B79FF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.988 19.906c2.11-.642 3.895-.965 5.355-.968 2.415-.006 4.439.472 6.073 1.434v-7c-1.642-.848-3.498-1.302-5.567-1.359a12.373 12.373 0 0 0-5.861 1.262v6.63Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      clipRule: 'evenodd',
      d: 'm12.56 12.284 2.604 6.187v-5.93a12.8 12.8 0 0 1 4.357-1.41c1.534-.206 3.276-.173 5.228.1l-1.416-3.377a12.668 12.668 0 0 0-5.865.99 14.508 14.508 0 0 0-4.909 3.44Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17.467 7.895 16.443 5.41a2.27 2.27 0 0 0-2.962-1.24l-7.08 2.918a2.27 2.27 0 0 0-1.228 2.967l6.814 16.533a2.27 2.27 0 0 0 2.962 1.24l7.08-2.918a2.27 2.27 0 0 0 1.229-2.967l-.845-2.05a28.778 28.778 0 0 0-.846-.04 23.717 23.717 0 0 0-.805-.002l1.099 2.667a.757.757 0 0 1-.41.99l-7.08 2.918a.757.757 0 0 1-.987-.414L6.57 9.481a.757.757 0 0 1 .409-.99l7.08-2.918a.757.757 0 0 1 .988.414l1.035 2.51c.32-.156.565-.268.737-.337.172-.069.388-.157.648-.265Z',
      fill: '#fff',
    }),
  );
});
mobilepaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mobilepay = {
  category: 'brand',
  colorable: false,
  name: 'mobilepay',
  svg: mobilepaySvg,
};
